// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"ee09fdc33b8a00d5","5763":"61405bdd1b3cbaef","6893":"7ef314eb1c87eeee","6974":"3dfcea9dbba8e314","7222":"64972b5b576f6f46","7937":"def4fd25418f4f14"}[chunkId] + ".js";
};